import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import MovieCard from '@/components/feature/MovieCard';
import EmptyState from '@/components/feature/EmptyState';
import { useFavorites } from '@/hooks/useFavorites';
import { movies, typeLabels } from '@/mocks/movies';

export default function FavoritesPage() {
  const { favorites } = useFavorites();
  const list = movies.filter((movie) => favorites.includes(movie.id));

  return (
    <SiteLayout
      title="我的收藏 - 丝瓜视频"
      description="丝瓜视频我的收藏页面，收藏的影视作品保存在本机浏览器中，随时回来继续浏览。"
      keywords="丝瓜视频,我的收藏,片单"
    >
      <main className="flex-1 w-full px-4 md:px-8 py-8 md:py-12 pb-16">
        <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-500 mb-3">
          <Link to="/" className="hover:text-primary-600 transition-colors">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span>我的收藏</span>
        </nav>

        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
          <div>
            <h1 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              我的收藏
            </h1>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600">
              共收藏 <span className="font-bold text-primary-600 font-label">{list.length}</span> 部作品 ·
              收藏记录保存在本机浏览器中，刷新与再次访问都会保留
            </p>
          </div>
          <Link
            to="/search"
            className="px-4 h-10 inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap w-fit"
          >
            <i className="ri-search-line"></i> 去找新作品
          </Link>
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-5">
            {list.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        ) : (
          <EmptyState
            title="收藏夹还是空的"
            description="在任意作品详情页点击「收藏这部作品」，它就会出现在这里。先去看看现在热门的电影、电视剧和综艺吧。"
            secondaryLabel="返回首页浏览"
            secondaryTo="/"
          />
        )}

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
          {(['movie', 'tv', 'variety'] as const).map((type) => (
            <Link
              key={type}
              to={`/category/${type}`}
              className="flex items-center justify-between px-4 py-3 rounded-lg bg-background-100 border border-background-200 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              <span className="flex items-center gap-2">
                <i
                  className={`${
                    type === 'movie' ? 'ri-film-line' : type === 'tv' ? 'ri-tv-2-line' : 'ri-mic-line'
                  } text-primary-500`}
                ></i>
                浏览{typeLabels[type]}
              </span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          ))}
        </div>
      </main>
    </SiteLayout>
  );
}